<template>
    <div class="container contact">
        <h1>Kontakt</h1>
        <hr>
        <div class="row pt-lg-5 pt-md-2 pt-sm-2 pb-3">
            <div class="col-lg-3 d-none d-md-block">
                <img src="./../assets/Entypo+/user.svg" alt="Marcin Barczewski" class="rounded-circle head-image"
                     width="200" height="200">
            </div>
            <div class="col-lg-9">
                <div class="row pt-lg-5">
                    <div class="col-9">
                        <div class="row">
                            <div class="col">
                                <h2>Marcin Barczewski</h2>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 col-sm-12 col-lg-6 pb-3 pb-lg-0">
								<span class="pr-2"><img src="./../assets/Entypo+/phone.svg" height="20"
                                                        width="20"/></span><a href="tel:+48662059167" class="pr-2">662
                                059 167</a>
                            </div>
                            <div class="col-md-12 col-sm-12 col-lg-6">
								<span class="pr-2"><img src="./../assets/Entypo+/mail.svg" height="20"
                                                        width="20"/></span><a href="mailto:fahumeble@gmail.com"
                                                                              class="pr-2">fahumeble@gmail.com</a>
                            </div>
                        </div>
                        <div class="row pt-3">
                            <div class="col col-sm-12">
								<span class="pr-2"><img src="./../assets/Entypo+/map.svg" height="20"
                                                        width="20"/></span>Kazimierza Drewnowskiego 8, Poznań
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row pt-lg-5 pt-md-2 pt-sm-2">
            <div class="col d-lg-none">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2435.796544243574!2d16.973201016158768!3d52.374109079786855!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47045a4e90b9d40f%3A0x494e0d7a4a8f9192!2sKazimierza+Drewnowskiego%2C+60-101+Pozna%C5%84!5e0!3m2!1spl!2spl!4v1549801369796"
                        width="400" height="300" frameborder="0" style="border:0" allowfullscreen></iframe>
            </div>
            <div class="col d-none d-md-block">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2435.796544243574!2d16.973201016158768!3d52.374109079786855!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47045a4e90b9d40f%3A0x494e0d7a4a8f9192!2sKazimierza+Drewnowskiego%2C+60-101+Pozna%C5%84!5e0!3m2!1spl!2spl!4v1549801369796"
                        width="600" height="450" frameborder="0" style="border:0" allowfullscreen></iframe>
            </div>
        </div>
    </div>
</template>


<script>
export default {};

</script>

<style>
    .contact {
        padding-top: 30px;
    }

    @media (min-width: 992px) {
        .contact {
            padding-top: 30px;
        }
    }
</style>
